"use client";
import { useModal } from "@/core/context/ModalContext";
import { showErrorMessage } from "@/utils/toastMessage/toast.message";
import { useSession } from "next-auth/react";
import Link from "next/link";
import React from "react";

const OverviewFooter = ({ price }: { price?: string }) => {
  const { status } = useSession();
  const isLoggedIn = status === "authenticated";

  const { openModal } = useModal();

  const handleNotLoggedIn = () => {
    openModal("login");
    showErrorMessage("Please login to access this feature.");
  };

  return (
    <>
      <div className="sticky bottom-0 z-20 bg-white flex justify-between my-3 shadow-[0px_0px_16px_0px_#00000014] py-5 px-6 rounded-t-3xl">
        <p className="typography-h6-regular font-medium">
          NRP {price || "0"}|-
        </p>
        {isLoggedIn ? (
          <Link href="/user/book/1">
            <button className="bg-primary-500 px-6 py-1.5 text-white rounded-md typography-sub-h3-light hover:bg-primary-600 cursor-pointer">
              Book Now
            </button>
          </Link>
        ) : (
          <div
            onClick={handleNotLoggedIn}
            className="bg-primary-500 px-6 py-1.5 text-white rounded-md typography-sub-h3-light hover:bg-primary-600 cursor-pointer"
          >
            Book Now
          </div>
        )}
      </div>
    </>
  );
};

export default OverviewFooter;
